// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.capPhep-itemForm-title {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: bolder;
  color: #000000cb;
  font-size: 16px;
}
.capPhep-listInput-containerOfParent {
  margin-left: 7px;
}
.capPhep-itemForm-titleHaTang {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: bolder;
  color: #000000cb;
  margin-top: 5px;
  font-size: 17px;
}
.capPhep-boxInput-contaier {
  margin-bottom: 5px;
}
.capPhep-boxInput-contaier-child {
  margin-left: 20px;
}
.capPhep-listInput-container {
  background-color: #f2f2f2;
  padding: 5px;
  border-radius: 5px;
}
.capPhep-listInput-collapse {
  background-color: #f2f2f2;
  border-radius: 3px;
  height: 43px;
}
.capPhep-listInput-collapse-child {
  /* margin-left: 8px; */
  /* margin-right: 0px; */
  padding-left: 8px;
}
.capPhep-listInput-collapse-child-notOfArray {
  margin-left: 20px;
  margin-right: 20px;
}
.capPhep-listInput-container-form {
  /* background-color: #f2f2f2;
    padding: 5px 5px 10px 5px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px; */
}
.capPhep-listInput-title {
  display: flex;
  position: relative;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}
.capPhep-listInput-removeItem {
  /* position: absolute; */
  /* top: -5px; */
  /* left: 50px; */
  margin-left: 15px;
  cursor: pointer;
  font-weight: bold;
  color: #bb2d2d;
  /* padding-top: 5px; */
  text-decoration: underline;
}
.capPhep-listInput-underlineItem {
  width: 100%;
  height: 1px;
  background-color: #2b713a;
}
.capPhep-listInput-dialog-title {
  text-align: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}
.diaLog-createObject-title {
  text-align: center;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
}
.capPhep-listInput-dialog-content {
  justify-content: space-around;
  margin-bottom: 10px;
  /* margin-right: 28%; */
}
.diaLog-createObject-content {
  margin: 0px 10px 0px 10px;
  width: 450px;
  justify-content: center;
}
.capPhep-listInput-dialog-buttonClose {
  width: 100px;
  height: 33px;
  margin-top: 5px;
  color: rgb(192, 44, 64);
}
.capPhep-listInput-dialog-buttonCheck {
  width: 100px;
  height: 33px;
  margin-top: 5px;
}
.capPhep-listInput-pushArray {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #2b713a;
  font-weight: 600;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
}
.capPhep-listInput-pushArray-buttonAdd {
  padding-right: 0.3rem;
}
.capPhep-input-buttonAdd {
  color: #2b713a;
}
.capPhep-itemForm-contaier {
  padding-left: 20;
}
.capPhep-advancedSearch-title {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  color: #2b713a;
  font-size: 15px;
  margin-bottom: 10px;
  font-style: italic;
  text-decoration: underline;
  cursor: pointer;
  width: 150px;
  margin-top: 3px;
}
.capPhep-advancedSearch-paper {
  background-color: #e6f7ef;
  position: absolute;
  inset: 0px auto auto 0px;
  transform: translate(0px, 43px);
  border: solid 1px #e1e1e1;
  width: 38vw;
  height: auto;
  margin-top: 45px;
  padding: 12px;
  border-radius: 5px;
  z-index: 1;
}
.capPhep-advancedSearch-paper-titleItem {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 15px;
}
.capPhep-advancedSearch-paper-containerAction {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 9px;
}
.capPhep-advancedSearch-paper-buttonReset {
  display: flex;
  align-items: center;
  color: #2b713a;
  cursor: pointer;
  margin-right: 5px;
  justify-content: center;
  width: 83px;
  border-radius: 5px;
}
.capPhep-advancedSearch-paper-buttonReset:hover {
  background-color: #d8eddc;
}
.capPhep-advancedSearch-contaierClose {
  padding-top: 0;
  display: "flex";
  flex-direction: "row-reverse";
}
.capPhep-advancedSearch-iconClose {
  cursor: pointer;
  border-radius: 5px;
  color: #2b713a;
}
.capPhep-advancedSearch-iconClose:hover {
  background-color: #d8eddc;
}
.capPhep-advancedSearch-contaierPaper {
  width: 100vw;
  height: 100vh;
  background-color: #a5bdaa;
}
.ag-border-right {
  border-right: solid 1px #e0e0e0;
}
.ag-border-thaotac-none {
  border: none;
}
.ag-grid-header-stt {
  font-weight: 500;
}
/* .ag-row-hover .mythaotac{
    background-color: #d4e9df !important;
    visibility: visible !important;
} */
.ag-row-hover .iconWhenHiddenMyThaoTac {
  visibility: hidden !important;
}
.capPhep-tableList-dtm-soHieuVanBan {
  text-decoration: underline;
  text-underline-offset: 3px;
  /* color: #2b713a; */
  cursor: pointer;
}
.capPhep-tableList-dtm-soHieuVanBan:hover {
  color: #3b8eee;
}
.capPhep-showDetail-dialog-title {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 20px;
  text-align: center;
  font-weight: 700;
  color: #2b713a;
}
/* .capPhep-showDetail-dialog-action{
    width: 70vw;
    height: 70vh;
} */
.capPhep-dialogDetail-content-contaier {
  width: 100%;
  height: 100%;
  padding: 0px 10px 10px 10px;
}
.capPhep-dialogDetail-content-thongTinChung-left {
  width: 50%;
  padding-right: 10px;
}
.capPhep-dialogDetail-content-thongTinChung-right {
  padding-right: 10px;
}
.capPhep-dialogDetail-content-contaier-right {
  width: 100%;
}
.capPhep-dialogDetail-content-thongTinChung-tdTitle {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 15px;
  font-weight: 600;
  width: 50%;
}
.capPhep-dialogDetail-content-thongTinChung-tdContent {
  font-weight: 400;
  border: 1px solid #dde2eb;
  border-collapse: collapse;
  padding: 5px 5px 5px 5px;
  width: 50%;
}
.capPhep-dialogDetail-content-file-table {
  border: 1px solid #dde2eb;
  border-collapse: collapse;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  /* font-family: "Roboto", "Helvetica", "Arial", sans-serif; */
  color: rgb(52, 71, 103);
  font-size: 15px;
}
.capPhep-dialogDetail-content-thongTinChung-tdTitle.ttchung {
  border: 1px solid #dde2eb;
  border-collapse: collapse;
  padding: 5px 5px 5px 5px;
}
.capPhep-dialogDetail-content-file-th.stt {
  border: 1px solid #dde2eb;
  height: 43px;
}
.capPhep-dialogDetail-content-file-td.stt {
  border: 1px solid #dde2eb;
  height: 35px;
}
.capPhep-dialogDetail-content-file-th,
.capPhep-dialogDetail-content-file-td {
  border-bottom: 1px solid #dde2eb;
}
.capPhep-dialogDetail-content-file-table {
  width: 100%;
}
.capPhep-dialogDetail-content-file-th {
  color: #344767;
  font-weight: 600;
  background-color: #f0f0f0;
}
.capPhep-dialogDetail-content-file-th.stt {
  text-align: center;
}
.capPhep-dialogDetail-content-file-td.stt {
  text-align: center;
}
.capPhep-dialogDetail-content-file-th.tenVanBan,
.capPhep-dialogDetail-content-file-td.tenVanBan {
  width: 200px;
  padding-left: 10px;
  padding-right: 10px;
}
.capPhep-dialogDetail-content-file-th.soHieuVanBan,
.capPhep-dialogDetail-content-file-td.soHieuVanBan {
  padding-left: 10px;
  padding-right: 10px;
  width: 160px;
}
.capPhep-dialogDetail-content-file-th.loaiTaiLieu,
.capPhep-dialogDetail-content-file-td.loaiTaiLieu {
  padding-left: 10px;
  padding-right: 10px;
  width: 160px;
}
.capPhep-dialogDetail-content-file-th.iconFile,
.capPhep-dialogDetail-content-file-td.iconFile {
  width: 50px;
  padding-left: 10px;
}
.capPhep-dialogDetail-content-file-th.tepDinhKem {
  width: 222px;
}
.capPhep-dialogDetail-content-file-th.loaiTaiLieu {
  max-width: 120px;
}
.capPhep-dialogDetail-content-contaierFile {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.capPhep-dialogDetail-content-file-tr:hover {
  background-color: #e2f7fc;
}
.capPhep-dialogDetail-content-file-table {
  width: 100%;
}
.capPhep-showDetail-dialog-iconClose {
  cursor: pointer;
  border-radius: 3px;
}
.capPhep-showDetail-dialog-iconClose:hover {
  background-color: #d1efd7cb;
}
.capPhep-dialogDetail-content-thongTinChung-contaier {
  display: flex;
  justify-content: center;
}
.capPhep-dialogDetail-content-thongTinChung-table {
  width: 90%;
}
.capPhep-dialogDetail-content-thongTinChung-titleElementP {
  float: left;
  margin-left: 60%;
}
.capPhep-dialogDetail-content-thongTinChung-titleElementP.giayPhepMt {
  margin-left: 42%;
}
.capPhep-dialogDetail-content-thongTinChung-titleElementP.chiTietDangKyKinhDoanh {
  margin-left: 10%;
}
.capPhep-dialogDetail-content-fileContent {
  width: 90%;
}
.capPhep-dialogDetail-content-thongTinChung-tdTitle.taiLieu {
  display: flex;
  width: 93%;
  margin-bottom: 10px;
}
.capPhep-dialog-content-loadding {
  width: 100%;
  display: flex;
  justify-content: center;
}
.capPhep-dialogDetail-content-thongtinDetail-contaier {
  display: flex;
  justify-content: center;
  margin-top: 3%;
}
.capPhep-dialogDetail-content-thongtinDetail-boxLeft {
  width: 45%;
  display: flex;
  justify-content: center;
}
.capPhep-dialogDetail-content-thongtinDetail-boxRight {
  width: 45%;
  display: flex;
  justify-content: center;
}
.capPhep-dialogDetail-content-thongtinDetail-box-item {
  display: flex;
}
.capPhep-dialogDetail-content-thongtinDetail-box-item-content {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 15px;
}
.capPhep-dialogDetail-content-thongtinDetail-box-item-title {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 15px;
  font-weight: 600;
}
.capPhep-dialogDetail-content-thongtinDetail-boxLeft-contaier {
  width: 90%;
}
.capPhep-dialogDetail-content-thongtinDetail-boxRight-contaier {
  width: 90%;
}
.capPhep-dialogDetail-content-thongTinChiTiet-table {
  width: 100%;
}
.capPhep-dialogDetail-content-thongtinDetail-box-title {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-size: 17px;
  font-weight: 700;
  text-align: center;
  padding-bottom: 10px;
}
.component-chitiet {
  height: calc(100vh - 50px);
  position: fixed;
  top: 85px;
  right: 0px;
  background-color: white;
  overflow: auto;
  z-index: 2;
  transition: all 0.3s ease-in-out;
  /* border-left: 1px solid #0000002d; */
  /* box-shadow: rgb(0 0 0 / 20%) 0px 8px 10px -5px, rgb(0 0 0 / 4%) 0px 16px 24px 2px, rgb(0 0 0 / 12%) 0px 6px 30px 5px; */
  &__thaotac {
    display: flex;
    gap: 5px;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 10px;
    padding-left: 10px;
  }
  &__content {
    padding: 0px 15px 20px 15px;
  }
}
.nguonThai-detailPage-title {
  text-align: center;
  color: #2b713ad9;
  text-transform: uppercase;
  font-size: larger;
  font-weight: bold;
  padding-bottom: 25px;
}
.nguonThai-detailPage-table-content {
  -ms-word-break: break-all;
  word-break: break-all;

  /* Non standard for webkit */
  word-break: break-word;

  -webkit-hyphens: auto;
  hyphens: auto;
}
.nguonThai-detailPage-table-lable {
  background-color: #f7f7f7;
  font-weight: 600;
}
.nguonThai-detailPage-table-lable,
.nguonThai-detailPage-table-content {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  border-bottom: solid 1px rgb(221, 221, 221);
  padding: 10px 10px 10px 10px;
  font-size: 15px;
}
.nguonThai-detailPage-table-lable-0,
.nguonThai-detailPage-table-content-0 {
  border-top: solid 1px rgb(221, 221, 221);
}
.nguonThai-detailPage-container-right {
  padding-left: 20px;
}
.nguonThai-detailPage-container-left {
  padding-right: 20px;
}
.nguonThai-detailPage-titleTable {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  padding-bottom: 12px;
  font-weight: 600;
  text-align: center;
  font-size: 17px;
}
.nguonThai-detailPage-container-big-second {
  /* padding-top: 10px; */
}
.capPhep-fontFamily {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
}
.MuiTableCell-root {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
}
.nguonThai-detailPage-titleTable-left {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  padding-bottom: 12px;
  font-weight: 600;
  text-align: left;
  font-size: 17px;
}
.nguonThai-detailPage-tableList-link {
  text-decoration: underline;
  /* text-underline-offset: 4px; */
  /* color: #2b713a; */
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
}
.nguonThai-detailPage-tableList-link:hover {
  color: #3b8eee;
}
.nguonThai-detailPage-giayPhepMt-buttonStatus-khongXacDinh {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  background-color: rgb(167, 167, 167);
  height: 25px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 14px;
  width: 100px;
}
.nguonThai-detailPage-giayPhepMt-buttonStatus-conHan {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  color: rgb(43, 113, 58);
  height: 25px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid rgb(43, 113, 58);
  font-size: 14px;
  width: 100px;
}
.nguonThai-detailPage-giayPhepMt-buttonStatus-hetHan {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  color: rgb(255, 82, 82);
  height: 25px;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid rgb(255, 82, 82);
  font-size: 14px;
  width: 100px;
}

.capPhep-detail-tabList-back {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  color: #2b713a;
  text-decoration: underline;
  text-underline-offset: 3px;
  font-size: 16px;
}
.MuiTableRow-root.MuiTableRow-hover:hover {
  background-color: red;
}
.nguonThai-detailPage-tableContainer {
  display: flex;
}
.nguonThai-detailPage-tableContainer-left {
  width: 50%;
  padding-right: 18px;
}
.nguonThai-detailPage-tableContainer-right {
  width: 50%;
  padding-left: 18px;
}
.nguonThai-detailPage-multiline {
  white-space: pre-line;
}
.custom-quill .ql-editor {
  min-height: 120px;
  font-size: 16px;
}

.image-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-width: 100%;
}

.image-wrapper {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 8px;
}

.image-item {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
}

.image-actions {
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  gap: 5px;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.image-wrapper:hover .image-actions {
  opacity: 1;
}

.action-btn {
  background: rgba(73, 73, 73, 0.6);
  color: white;
  padding: 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.action-btn:hover {
  background: rgba(50, 50, 50, 0.8);
}

/* Style cho ảnh mẫu (nút thêm ảnh) */
.add-image {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border: 2px dashed #ccc;
  cursor: pointer;
}

.add-image:hover {
  background: #e0e0e0;
}

.title-page-cau-hinh-hien-thi {
  width: 100%;
  font-size: 25px;
  font-weight: 700;
  margin: 10px 0px 10px 33px;
  color: #2b713a;
}
.viTriDiaLy_message_correct {
  color: rgb(43, 113, 58);
  /* text-decoration: underline; */
  margin-left: 10px;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Lib/style.css"],"names":[],"mappings":"AAAA;EACE,uDAAuD;EACvD,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uDAAuD;EACvD,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE;;;sCAGoC;AACtC;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,uDAAuD;AACzD;AACA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;AACA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uDAAuD;EACvD,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,uDAAuD;EACvD,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;;;GAGG;AACH;EACE,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE;gEAC8D;EAC9D,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;;;GAGG;AACH;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,uDAAuD;EACvD,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB;gEAC8D;EAC9D,6DAA6D;EAC7D,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;;EAEE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE;gEAC8D;EAC9D,eAAe;AACjB;AACA;EACE;gEAC8D;EAC9D,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE;gEAC8D;EAC9D,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,gCAAgC;EAChC,sCAAsC;EACtC,0HAA0H;EAC1H;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,qBAAqB;;EAErB,4BAA4B;EAC5B,sBAAsB;;EAEtB,qBAAqB;EAGrB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;;EAEE;gEAC8D;EAC9D,2CAA2C;EAC3C,4BAA4B;EAC5B,eAAe;AACjB;AACA;;EAEE,wCAAwC;AAC1C;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE;gEAC8D;EAC9D,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE;gEAC8D;AAChE;AACA;EACE;gEAC8D;AAChE;AACA;EACE;gEAC8D;EAC9D,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE;gEAC8D;EAC9D,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE;gEAC8D;EAC9D,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,YAAY;AACd;AACA;EACE;gEAC8D;EAC9D,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB;gEAC8D;EAC9D,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,QAAQ;EACR,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".capPhep-itemForm-title {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-weight: bolder;\r\n  color: #000000cb;\r\n  font-size: 16px;\r\n}\r\n.capPhep-listInput-containerOfParent {\r\n  margin-left: 7px;\r\n}\r\n.capPhep-itemForm-titleHaTang {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-weight: bolder;\r\n  color: #000000cb;\r\n  margin-top: 5px;\r\n  font-size: 17px;\r\n}\r\n.capPhep-boxInput-contaier {\r\n  margin-bottom: 5px;\r\n}\r\n.capPhep-boxInput-contaier-child {\r\n  margin-left: 20px;\r\n}\r\n.capPhep-listInput-container {\r\n  background-color: #f2f2f2;\r\n  padding: 5px;\r\n  border-radius: 5px;\r\n}\r\n.capPhep-listInput-collapse {\r\n  background-color: #f2f2f2;\r\n  border-radius: 3px;\r\n  height: 43px;\r\n}\r\n.capPhep-listInput-collapse-child {\r\n  /* margin-left: 8px; */\r\n  /* margin-right: 0px; */\r\n  padding-left: 8px;\r\n}\r\n.capPhep-listInput-collapse-child-notOfArray {\r\n  margin-left: 20px;\r\n  margin-right: 20px;\r\n}\r\n.capPhep-listInput-container-form {\r\n  /* background-color: #f2f2f2;\r\n    padding: 5px 5px 10px 5px;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 3px; */\r\n}\r\n.capPhep-listInput-title {\r\n  display: flex;\r\n  position: relative;\r\n  font-size: 15px;\r\n  font-style: italic;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n}\r\n.capPhep-listInput-removeItem {\r\n  /* position: absolute; */\r\n  /* top: -5px; */\r\n  /* left: 50px; */\r\n  margin-left: 15px;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  color: #bb2d2d;\r\n  /* padding-top: 5px; */\r\n  text-decoration: underline;\r\n}\r\n.capPhep-listInput-underlineItem {\r\n  width: 100%;\r\n  height: 1px;\r\n  background-color: #2b713a;\r\n}\r\n.capPhep-listInput-dialog-title {\r\n  text-align: center;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n}\r\n.diaLog-createObject-title {\r\n  text-align: center;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n}\r\n.capPhep-listInput-dialog-content {\r\n  justify-content: space-around;\r\n  margin-bottom: 10px;\r\n  /* margin-right: 28%; */\r\n}\r\n.diaLog-createObject-content {\r\n  margin: 0px 10px 0px 10px;\r\n  width: 450px;\r\n  justify-content: center;\r\n}\r\n.capPhep-listInput-dialog-buttonClose {\r\n  width: 100px;\r\n  height: 33px;\r\n  margin-top: 5px;\r\n  color: rgb(192, 44, 64);\r\n}\r\n.capPhep-listInput-dialog-buttonCheck {\r\n  width: 100px;\r\n  height: 33px;\r\n  margin-top: 5px;\r\n}\r\n.capPhep-listInput-pushArray {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  color: #2b713a;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  width: fit-content;\r\n}\r\n.capPhep-listInput-pushArray-buttonAdd {\r\n  padding-right: 0.3rem;\r\n}\r\n.capPhep-input-buttonAdd {\r\n  color: #2b713a;\r\n}\r\n.capPhep-itemForm-contaier {\r\n  padding-left: 20;\r\n}\r\n.capPhep-advancedSearch-title {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  color: #2b713a;\r\n  font-size: 15px;\r\n  margin-bottom: 10px;\r\n  font-style: italic;\r\n  text-decoration: underline;\r\n  cursor: pointer;\r\n  width: 150px;\r\n  margin-top: 3px;\r\n}\r\n.capPhep-advancedSearch-paper {\r\n  background-color: #e6f7ef;\r\n  position: absolute;\r\n  inset: 0px auto auto 0px;\r\n  transform: translate(0px, 43px);\r\n  border: solid 1px #e1e1e1;\r\n  width: 38vw;\r\n  height: auto;\r\n  margin-top: 45px;\r\n  padding: 12px;\r\n  border-radius: 5px;\r\n  z-index: 1;\r\n}\r\n.capPhep-advancedSearch-paper-titleItem {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-size: 15px;\r\n}\r\n.capPhep-advancedSearch-paper-containerAction {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  width: 100%;\r\n  margin-top: 9px;\r\n}\r\n.capPhep-advancedSearch-paper-buttonReset {\r\n  display: flex;\r\n  align-items: center;\r\n  color: #2b713a;\r\n  cursor: pointer;\r\n  margin-right: 5px;\r\n  justify-content: center;\r\n  width: 83px;\r\n  border-radius: 5px;\r\n}\r\n.capPhep-advancedSearch-paper-buttonReset:hover {\r\n  background-color: #d8eddc;\r\n}\r\n.capPhep-advancedSearch-contaierClose {\r\n  padding-top: 0;\r\n  display: \"flex\";\r\n  flex-direction: \"row-reverse\";\r\n}\r\n.capPhep-advancedSearch-iconClose {\r\n  cursor: pointer;\r\n  border-radius: 5px;\r\n  color: #2b713a;\r\n}\r\n.capPhep-advancedSearch-iconClose:hover {\r\n  background-color: #d8eddc;\r\n}\r\n.capPhep-advancedSearch-contaierPaper {\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background-color: #a5bdaa;\r\n}\r\n.ag-border-right {\r\n  border-right: solid 1px #e0e0e0;\r\n}\r\n.ag-border-thaotac-none {\r\n  border: none;\r\n}\r\n.ag-grid-header-stt {\r\n  font-weight: 500;\r\n}\r\n/* .ag-row-hover .mythaotac{\r\n    background-color: #d4e9df !important;\r\n    visibility: visible !important;\r\n} */\r\n.ag-row-hover .iconWhenHiddenMyThaoTac {\r\n  visibility: hidden !important;\r\n}\r\n.capPhep-tableList-dtm-soHieuVanBan {\r\n  text-decoration: underline;\r\n  text-underline-offset: 3px;\r\n  /* color: #2b713a; */\r\n  cursor: pointer;\r\n}\r\n.capPhep-tableList-dtm-soHieuVanBan:hover {\r\n  color: #3b8eee;\r\n}\r\n.capPhep-showDetail-dialog-title {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n  font-size: 20px;\r\n  text-align: center;\r\n  font-weight: 700;\r\n  color: #2b713a;\r\n}\r\n/* .capPhep-showDetail-dialog-action{\r\n    width: 70vw;\r\n    height: 70vh;\r\n} */\r\n.capPhep-dialogDetail-content-contaier {\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 0px 10px 10px 10px;\r\n}\r\n.capPhep-dialogDetail-content-thongTinChung-left {\r\n  width: 50%;\r\n  padding-right: 10px;\r\n}\r\n.capPhep-dialogDetail-content-thongTinChung-right {\r\n  padding-right: 10px;\r\n}\r\n.capPhep-dialogDetail-content-contaier-right {\r\n  width: 100%;\r\n}\r\n.capPhep-dialogDetail-content-thongTinChung-tdTitle {\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  width: 50%;\r\n}\r\n.capPhep-dialogDetail-content-thongTinChung-tdContent {\r\n  font-weight: 400;\r\n  border: 1px solid #dde2eb;\r\n  border-collapse: collapse;\r\n  padding: 5px 5px 5px 5px;\r\n  width: 50%;\r\n}\r\n.capPhep-dialogDetail-content-file-table {\r\n  border: 1px solid #dde2eb;\r\n  border-collapse: collapse;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n  /* font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif; */\r\n  color: rgb(52, 71, 103);\r\n  font-size: 15px;\r\n}\r\n.capPhep-dialogDetail-content-thongTinChung-tdTitle.ttchung {\r\n  border: 1px solid #dde2eb;\r\n  border-collapse: collapse;\r\n  padding: 5px 5px 5px 5px;\r\n}\r\n.capPhep-dialogDetail-content-file-th.stt {\r\n  border: 1px solid #dde2eb;\r\n  height: 43px;\r\n}\r\n.capPhep-dialogDetail-content-file-td.stt {\r\n  border: 1px solid #dde2eb;\r\n  height: 35px;\r\n}\r\n.capPhep-dialogDetail-content-file-th,\r\n.capPhep-dialogDetail-content-file-td {\r\n  border-bottom: 1px solid #dde2eb;\r\n}\r\n.capPhep-dialogDetail-content-file-table {\r\n  width: 100%;\r\n}\r\n.capPhep-dialogDetail-content-file-th {\r\n  color: #344767;\r\n  font-weight: 600;\r\n  background-color: #f0f0f0;\r\n}\r\n.capPhep-dialogDetail-content-file-th.stt {\r\n  text-align: center;\r\n}\r\n.capPhep-dialogDetail-content-file-td.stt {\r\n  text-align: center;\r\n}\r\n.capPhep-dialogDetail-content-file-th.tenVanBan,\r\n.capPhep-dialogDetail-content-file-td.tenVanBan {\r\n  width: 200px;\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n}\r\n.capPhep-dialogDetail-content-file-th.soHieuVanBan,\r\n.capPhep-dialogDetail-content-file-td.soHieuVanBan {\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n  width: 160px;\r\n}\r\n.capPhep-dialogDetail-content-file-th.loaiTaiLieu,\r\n.capPhep-dialogDetail-content-file-td.loaiTaiLieu {\r\n  padding-left: 10px;\r\n  padding-right: 10px;\r\n  width: 160px;\r\n}\r\n.capPhep-dialogDetail-content-file-th.iconFile,\r\n.capPhep-dialogDetail-content-file-td.iconFile {\r\n  width: 50px;\r\n  padding-left: 10px;\r\n}\r\n.capPhep-dialogDetail-content-file-th.tepDinhKem {\r\n  width: 222px;\r\n}\r\n.capPhep-dialogDetail-content-file-th.loaiTaiLieu {\r\n  max-width: 120px;\r\n}\r\n.capPhep-dialogDetail-content-contaierFile {\r\n  margin-top: 20px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.capPhep-dialogDetail-content-file-tr:hover {\r\n  background-color: #e2f7fc;\r\n}\r\n.capPhep-dialogDetail-content-file-table {\r\n  width: 100%;\r\n}\r\n.capPhep-showDetail-dialog-iconClose {\r\n  cursor: pointer;\r\n  border-radius: 3px;\r\n}\r\n.capPhep-showDetail-dialog-iconClose:hover {\r\n  background-color: #d1efd7cb;\r\n}\r\n.capPhep-dialogDetail-content-thongTinChung-contaier {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.capPhep-dialogDetail-content-thongTinChung-table {\r\n  width: 90%;\r\n}\r\n.capPhep-dialogDetail-content-thongTinChung-titleElementP {\r\n  float: left;\r\n  margin-left: 60%;\r\n}\r\n.capPhep-dialogDetail-content-thongTinChung-titleElementP.giayPhepMt {\r\n  margin-left: 42%;\r\n}\r\n.capPhep-dialogDetail-content-thongTinChung-titleElementP.chiTietDangKyKinhDoanh {\r\n  margin-left: 10%;\r\n}\r\n.capPhep-dialogDetail-content-fileContent {\r\n  width: 90%;\r\n}\r\n.capPhep-dialogDetail-content-thongTinChung-tdTitle.taiLieu {\r\n  display: flex;\r\n  width: 93%;\r\n  margin-bottom: 10px;\r\n}\r\n.capPhep-dialog-content-loadding {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.capPhep-dialogDetail-content-thongtinDetail-contaier {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-top: 3%;\r\n}\r\n.capPhep-dialogDetail-content-thongtinDetail-boxLeft {\r\n  width: 45%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.capPhep-dialogDetail-content-thongtinDetail-boxRight {\r\n  width: 45%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.capPhep-dialogDetail-content-thongtinDetail-box-item {\r\n  display: flex;\r\n}\r\n.capPhep-dialogDetail-content-thongtinDetail-box-item-content {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n  font-size: 15px;\r\n}\r\n.capPhep-dialogDetail-content-thongtinDetail-box-item-title {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n}\r\n.capPhep-dialogDetail-content-thongtinDetail-boxLeft-contaier {\r\n  width: 90%;\r\n}\r\n.capPhep-dialogDetail-content-thongtinDetail-boxRight-contaier {\r\n  width: 90%;\r\n}\r\n.capPhep-dialogDetail-content-thongTinChiTiet-table {\r\n  width: 100%;\r\n}\r\n.capPhep-dialogDetail-content-thongtinDetail-box-title {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  text-align: center;\r\n  padding-bottom: 10px;\r\n}\r\n.component-chitiet {\r\n  height: calc(100vh - 50px);\r\n  position: fixed;\r\n  top: 85px;\r\n  right: 0px;\r\n  background-color: white;\r\n  overflow: auto;\r\n  z-index: 2;\r\n  transition: all 0.3s ease-in-out;\r\n  /* border-left: 1px solid #0000002d; */\r\n  /* box-shadow: rgb(0 0 0 / 20%) 0px 8px 10px -5px, rgb(0 0 0 / 4%) 0px 16px 24px 2px, rgb(0 0 0 / 12%) 0px 6px 30px 5px; */\r\n  &__thaotac {\r\n    display: flex;\r\n    gap: 5px;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n    margin-top: 10px;\r\n    padding-left: 10px;\r\n  }\r\n  &__content {\r\n    padding: 0px 15px 20px 15px;\r\n  }\r\n}\r\n.nguonThai-detailPage-title {\r\n  text-align: center;\r\n  color: #2b713ad9;\r\n  text-transform: uppercase;\r\n  font-size: larger;\r\n  font-weight: bold;\r\n  padding-bottom: 25px;\r\n}\r\n.nguonThai-detailPage-table-content {\r\n  -ms-word-break: break-all;\r\n  word-break: break-all;\r\n\r\n  /* Non standard for webkit */\r\n  word-break: break-word;\r\n\r\n  -webkit-hyphens: auto;\r\n  -moz-hyphens: auto;\r\n  -ms-hyphens: auto;\r\n  hyphens: auto;\r\n}\r\n.nguonThai-detailPage-table-lable {\r\n  background-color: #f7f7f7;\r\n  font-weight: 600;\r\n}\r\n.nguonThai-detailPage-table-lable,\r\n.nguonThai-detailPage-table-content {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n  border-bottom: solid 1px rgb(221, 221, 221);\r\n  padding: 10px 10px 10px 10px;\r\n  font-size: 15px;\r\n}\r\n.nguonThai-detailPage-table-lable-0,\r\n.nguonThai-detailPage-table-content-0 {\r\n  border-top: solid 1px rgb(221, 221, 221);\r\n}\r\n.nguonThai-detailPage-container-right {\r\n  padding-left: 20px;\r\n}\r\n.nguonThai-detailPage-container-left {\r\n  padding-right: 20px;\r\n}\r\n.nguonThai-detailPage-titleTable {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n  padding-bottom: 12px;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  font-size: 17px;\r\n}\r\n.nguonThai-detailPage-container-big-second {\r\n  /* padding-top: 10px; */\r\n}\r\n.capPhep-fontFamily {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n}\r\n.MuiTableCell-root {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n}\r\n.nguonThai-detailPage-titleTable-left {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n  padding-bottom: 12px;\r\n  font-weight: 600;\r\n  text-align: left;\r\n  font-size: 17px;\r\n}\r\n.nguonThai-detailPage-tableList-link {\r\n  text-decoration: underline;\r\n  /* text-underline-offset: 4px; */\r\n  /* color: #2b713a; */\r\n  cursor: pointer;\r\n  width: fit-content;\r\n}\r\n.nguonThai-detailPage-tableList-link:hover {\r\n  color: #3b8eee;\r\n}\r\n.nguonThai-detailPage-giayPhepMt-buttonStatus-khongXacDinh {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n  background-color: rgb(167, 167, 167);\r\n  height: 25px;\r\n  border-radius: 6px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: white;\r\n  font-size: 14px;\r\n  width: 100px;\r\n}\r\n.nguonThai-detailPage-giayPhepMt-buttonStatus-conHan {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n  color: rgb(43, 113, 58);\r\n  height: 25px;\r\n  border-radius: 6px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border: 2px solid rgb(43, 113, 58);\r\n  font-size: 14px;\r\n  width: 100px;\r\n}\r\n.nguonThai-detailPage-giayPhepMt-buttonStatus-hetHan {\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n  color: rgb(255, 82, 82);\r\n  height: 25px;\r\n  border-radius: 6px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border: 2px solid rgb(255, 82, 82);\r\n  font-size: 14px;\r\n  width: 100px;\r\n}\r\n\r\n.capPhep-detail-tabList-back {\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\r\n    Oxygen-Sans, Ubuntu, Cantarell, \"Helvetica Neue\", sans-serif;\r\n  color: #2b713a;\r\n  text-decoration: underline;\r\n  text-underline-offset: 3px;\r\n  font-size: 16px;\r\n}\r\n.MuiTableRow-root.MuiTableRow-hover:hover {\r\n  background-color: red;\r\n}\r\n.nguonThai-detailPage-tableContainer {\r\n  display: flex;\r\n}\r\n.nguonThai-detailPage-tableContainer-left {\r\n  width: 50%;\r\n  padding-right: 18px;\r\n}\r\n.nguonThai-detailPage-tableContainer-right {\r\n  width: 50%;\r\n  padding-left: 18px;\r\n}\r\n.nguonThai-detailPage-multiline {\r\n  white-space: pre-line;\r\n}\r\n.custom-quill .ql-editor {\r\n  min-height: 120px;\r\n  font-size: 16px;\r\n}\r\n\r\n.image-container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  max-width: 100%;\r\n}\r\n\r\n.image-wrapper {\r\n  position: relative;\r\n  width: 200px;\r\n  height: 200px;\r\n  overflow: hidden;\r\n  border-radius: 8px;\r\n}\r\n\r\n.image-item {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.image-actions {\r\n  position: absolute;\r\n  top: 5px;\r\n  right: 5px;\r\n  display: flex;\r\n  gap: 5px;\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease-in-out;\r\n}\r\n\r\n.image-wrapper:hover .image-actions {\r\n  opacity: 1;\r\n}\r\n\r\n.action-btn {\r\n  background: rgba(73, 73, 73, 0.6);\r\n  color: white;\r\n  padding: 5px;\r\n  border: none;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n}\r\n\r\n.action-btn:hover {\r\n  background: rgba(50, 50, 50, 0.8);\r\n}\r\n\r\n/* Style cho ảnh mẫu (nút thêm ảnh) */\r\n.add-image {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #f0f0f0;\r\n  border: 2px dashed #ccc;\r\n  cursor: pointer;\r\n}\r\n\r\n.add-image:hover {\r\n  background: #e0e0e0;\r\n}\r\n\r\n.title-page-cau-hinh-hien-thi {\r\n  width: 100%;\r\n  font-size: 25px;\r\n  font-weight: 700;\r\n  margin: 10px 0px 10px 33px;\r\n  color: #2b713a;\r\n}\r\n.viTriDiaLy_message_correct {\r\n  color: rgb(43, 113, 58);\r\n  /* text-decoration: underline; */\r\n  margin-left: 10px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
